import { Ploc, VIEWPORT_NAMES } from '@hfc/ui-core';
import { SmallBusinessPlan } from '@/application/smallBusiness/domain/SmallBusinessPlan';
import { PlanResponse } from '@/planList/domain/PlanResponse';

export interface ComparePlansStoreInterface {
  openComparisonModal: boolean;
  loadingPlansToCompare: boolean;
  plansToCompare: Array<SmallBusinessPlan | PlanResponse>;
  disableComparison: boolean;
  plansLimit: number;
}

const initialState: ComparePlansStoreInterface = {
  openComparisonModal: false,
  loadingPlansToCompare: false,
  plansToCompare: [] as Array<SmallBusinessPlan | PlanResponse>,
  disableComparison: false,
  plansLimit: 5,
};

export class ComparePlansStore extends Ploc<ComparePlansStoreInterface> {

  public constructor () {
    super(initialState);
  }

  public async addPlanToCompare (plan: SmallBusinessPlan | PlanResponse): Promise<void> {
    const plansToCompare = [...this.state.plansToCompare, plan];
    this.changeState({ ...this.state, plansToCompare });
    this.checkPlansToCompareLimit();
  }

  public async addPlansToCompare (plans: Array<SmallBusinessPlan | PlanResponse>): Promise<void> {
    if (plans.length > this.state.plansLimit) {
      return this.changeState({ ...this.state, disableComparison: true });
    }

    this.changeState({ ...this.state, openComparisonModal: true, plansToCompare: [...plans] });
    this.checkPlansToCompareLimit();
    this.setLoadingPlansToCompare(false);
  }

  public async removePlanToCompare (reference_id: string): Promise<void> {
    const newPlansToCompare = this.state.plansToCompare.filter(plan => plan.reference_id !== reference_id);
    this.changeState({ ...this.state, plansToCompare: newPlansToCompare });
    this.checkPlansToCompareLimit();
  }

  public async emptyPlansToCompare (checkComparisonLimit = true): Promise<void> {
    this.changeState({ ...this.state, plansToCompare: [] });

    if (checkComparisonLimit) {
      this.checkPlansToCompareLimit();
    }
  }

  public changeComparisonModalState (): void {
    this.changeState({ ...this.state, openComparisonModal: !this.state.openComparisonModal });
  }

  public async checkPlansToCompareLimit (): Promise<void> {
    if (this.state.plansToCompare.length >= this.state.plansLimit) {
      return this.changeState({ ...this.state, disableComparison: true });
    }

    if (this.state.plansToCompare.length <= 1) {
      this.changeState({ ...this.state, openComparisonModal: false });
    }
    this.changeState({ ...this.state, disableComparison: false });
  }

  public setPlansMaxLimit (viewportName: string): void {
    if (viewportName === VIEWPORT_NAMES.ALL || viewportName === VIEWPORT_NAMES.SM) {
      return this.changeState({ ...this.state, plansLimit: 2 });
    }
    if (viewportName === VIEWPORT_NAMES.MD) {
      return this.changeState({ ...this.state, plansLimit: 3 });
    }

    return this.changeState({ ...this.state, plansLimit: 5 });
  }

  public setLoadingPlansToCompare (loading: boolean): void {
    this.changeState({ ...this.state, loadingPlansToCompare: loading });
  }

}
